import type { CityConfig } from "../city-template/types";

export const brookingsConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Brookings",
  state: "South Dakota",
  stateAbbr: "SD",
  slug: "brookings",
  route: "/brookings",
  title: "Emergency Passport Brookings, SD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Brookings, SD — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving SDSU students, Brookings County families, 3M/Daktronics professionals, and eastern South Dakota travelers.",
  h1: "Emergency & Expedited Passport Services in Brookings, SD",
  heroSubtitle: "SDSU study abroad program starting in two weeks? 3M or Daktronics international business trip to Asia or Europe? Brookings County family planning a first overseas vacation? We help Brookings residents — from SDSU faculty and students to manufacturing professionals to multi-generational farm families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20South%20Dakota%20State%20University%20campus%20in%20Brookings%20South%20Dakota%20during%20autumn%20with%20the%20iconic%20Coughlin%20Campanile%20bell%20tower%2C%20red%20brick%20academic%20buildings%20surrounded%20by%20golden%20fall%20foliage%2C%20wide%20open%20Great%20Plains%20sky%20with%20dramatic%20sunset%20clouds%2C%20warm%20afternoon%20light%20casting%20long%20shadows%20across%20the%20college%20green%2C%20peaceful%20Midwestern%20university%20town%20atmosphere&width=1800&height=700&seq=brookings-hero-2026&orientation=landscape",
  heroImageAlt: "South Dakota State University campus in Brookings with Coughlin Campanile at autumn sunset",
  geoPosition: "44.3114;-96.7984",
  geoPlacename: "Brookings, South Dakota",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located approximately 230 miles northeast of Brookings via I-29 — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Brookings", zips: "57006, 57007" },
    { name: "Volga", zips: "57071" },
    { name: "White", zips: "57276" },
    { name: "Bruce", zips: "57220" },
    { name: "Elkton", zips: "57026" },
    { name: "Aurora", zips: "57002" },
    { name: "Flandreau", zips: "57028" },
    { name: "Arlington", zips: "57212" },
    { name: "Lake Preston", zips: "57249" },
    { name: "De Smet", zips: "57231" },
    { name: "Madison", zips: "57042" },
    { name: "Clear Lake", zips: "57226" },
    { name: "Estelline", zips: "57234" },
    { name: "Toronto", zips: "57268" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the Minneapolis Passport Agency — as fast as 24 hours for Brookings-area travelers with immediate departures." },
    { icon: "ri-graduation-cap-line", title: "SDSU Study Abroad Expertise", desc: "Thousands of SDSU Jackrabbits study abroad each year. We know program timelines, acceptance-to-departure windows, and first-time passport requirements." },
    { icon: "ri-building-2-line", title: "Manufacturing & Tech Travel Ready", desc: "3M, Daktronics, Larson Manufacturing, and Bel Brands professionals traveling internationally — we handle the passport so you handle the business." },
    { icon: "ri-flight-takeoff-line", title: "Sioux Falls Airport Access", desc: "FSD is just 55 miles south with connections to MSP, ORD, and DEN international gateways. We coordinate timelines around your regional flight connections." },
  ],
  internalLinks: [
    { name: "Fast passport services in Sioux Falls, SD", route: "/sioux-falls" },
    { name: "Expedited passport in Rapid City, SD", route: "/rapid-city" },
    { name: "Quick passport services in Watertown, SD", route: "/watertown-sd" },
    { name: "Urgent passport services in Aberdeen, SD", route: "/aberdeen-sd" },
    { name: "South Dakota passport services overview", route: "/south-dakota" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Brookings via secure registered courier with direct access to the Minneapolis Passport Agency at 212 3rd Ave S, Minneapolis. Our registered couriers hand-deliver your documents — meaning you get faster results without the 230-mile drive. Brookings residents can ship from any UPS Store, FedEx Office, or post office location across Brookings County.",
  fpcOfficeDistance: "Serving Brookings, Volga, White, Bruce, Elkton, Flandreau, and all Brookings County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Brookings and Brookings County. From the SDSU campus district to the downtown business corridor, from the manufacturing parks to the surrounding agricultural communities — we serve all of Brookings County and adjacent areas. Our courier service eliminates the need to drive four hours to the Minneapolis Passport Agency or wait for a post office appointment.",
  nearbyCitiesIntro: "We serve Brookings and surrounding communities including Volga, White, Bruce, Elkton, Aurora, Flandreau, Arlington, Lake Preston, De Smet, Madison, Clear Lake, and Estelline. We also serve SDSU students and faculty departing from Sioux Falls Regional Airport (FSD) who need expedited passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Brookings as simple as possible — with the efficiency and reliability SDSU students, manufacturing professionals, and Brookings County families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Brookings travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Brookings travelers encounter unique passport issues — everything from SDSU study abroad deadlines to 6-month validity rules for manufacturing business trips to Asia. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Brookings travelers — from SDSU Jackrabbits to 3M professionals to Brookings County families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Brookings, SD? Here are the most common ones we hear from Brookings County travelers.",
  statePageRoute: "/states/south-dakota",
  statePageName: "South Dakota",
  servicesIntro: "Whether you need a renewal before an SDSU study abroad semester, an emergency passport for a last-minute 3M or Daktronics business trip, or a first-time passport for a Brookings County family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dps.sd.gov/driver-licensing",
  dmvLabel: "South Dakota DPS Driver Licensing — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "SDSU study abroad orientation in 3 days? Daktronics international client meeting this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Brookings-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Brookings residents renew fast — no agency visit required for most renewals. Perfect for SDSU faculty, 3M professionals, and Brookings County families preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Brookings residents through every step — from SDSU students to farm families — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your international business trip or study abroad semester is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family trip abroad or SDSU faculty sabbatical stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Brookings professionals after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Brookings manufacturing executives and SDSU researchers who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Brookings-area travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Brookings SD", description: "Urgent passport processing for Brookings South Dakota travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Brookings SD", description: "Fast passport renewal for Brookings South Dakota residents with a previously-issued passport." },
    { name: "First-Time Passport Brookings SD", description: "New passport application services for Brookings South Dakota residents applying for their first passport." },
    { name: "Child Passport Brookings SD", description: "Minor passport services for Brookings South Dakota families with children under 16." },
    { name: "Name Change Passport Brookings SD", description: "Passport name correction after marriage, divorce, or legal name changes for Brookings residents." },
    { name: "Second Passport Brookings SD", description: "Second passport services for Brookings corporate executives and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Megan R.",
      location: "SDSU Student, Brookings",
      rating: 5,
      text: "I got accepted to study abroad in Spain with only 3 weeks before departure and had never had a passport. Fast Passport Center walked me through the first-time application and my passport arrived in 6 days. I made it to orientation on time!",
      service: "First-Time Passport",
    },
    {
      name: "Tom H.",
      location: "3M Engineer, Brookings",
      rating: 5,
      text: "Got called to our Germany plant for an emergency project with 8 days notice. My passport was expired and Fast Passport Center got it renewed in 4 business days. Saved the entire trip.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Olson Family",
      location: "Brookings County",
      rating: 5,
      text: "We booked a long-awaited family trip to Norway to visit relatives and realized all three kids needed first-time passports. They guided us through everything and all three came back in time.",
      service: "Child Passports",
    },
    {
      name: "Lisa K.",
      location: "SDSU Faculty, Brookings",
      rating: 5,
      text: "Needed a name change on my passport before a research conference in Tokyo. The document review caught a detail I missed and prevented what would have been a rejection. Incredibly thorough service.",
      service: "Name Change Passport",
    },
  ],
  facilities: [
    {
      id: "brookings-1",
      name: "Brookings Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "500 Main Ave",
      city: "Brookings",
      state: "SD",
      zip: "57006",
      phone: "(605) 692-4711",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Brookings",
      website: "https://tools.usps.com/find-location.htm?location=1368320",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility serving Brookings and Brookings County. Passport photos available. Appointment strongly recommended — limited walk-in capacity.",
      icon: "ri-mail-line",
    },
    {
      id: "brookings-2",
      name: "Brookings County Clerk of Courts",
      type: "County Clerk Passport Acceptance",
      address: "314 6th Ave",
      city: "Brookings",
      state: "SD",
      zip: "57006",
      phone: "(605) 696-8240",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Brookings County Courthouse",
      website: "https://www.brookingscountysd.gov/",
      websiteLabel: "Brookings County",
      notes: "County clerk office offering passport acceptance services. Convenient for SDSU students and Brookings residents. Call ahead to confirm clerk availability.",
      icon: "ri-government-line",
    },
    {
      id: "brookings-3",
      name: "Flandreau Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 E 2nd Ave",
      city: "Flandreau",
      state: "SD",
      zip: "57028",
      phone: "(605) 997-2751",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Flandreau — 22 miles southeast",
      website: "https://tools.usps.com/find-location.htm?location=1368336",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for Moody County residents and southeastern Brookings County. Appointment recommended. Limited photo services — call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "brookings-4",
      name: "Madison Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 N Egan Ave",
      city: "Madison",
      state: "SD",
      zip: "57042",
      phone: "(605) 256-4926",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Madison — 25 miles southwest",
      website: "https://tools.usps.com/find-location.htm?location=1368394",
      websiteLabel: "USPS Location",
      notes: "Serves Lake County including Madison and surrounding rural areas. Passport photos available. DSU students may find this location convenient.",
      icon: "ri-mail-line",
    },
    {
      id: "brookings-5",
      name: "Sioux Falls Downtown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "320 S 2nd Ave",
      city: "Sioux Falls",
      state: "SD",
      zip: "57104",
      phone: "(605) 336-3343",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Sioux Falls — 55 miles south",
      website: "https://tools.usps.com/find-location.htm?location=1368468",
      websiteLabel: "USPS Location",
      notes: "Largest acceptance facility in the region serving Sioux Falls and surrounding communities. Full photo services. Worth the drive for guaranteed availability — appointments fill fast during peak travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "brookings-6",
      name: "Watertown Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "405 E Kemp Ave",
      city: "Watertown",
      state: "SD",
      zip: "57201",
      phone: "(605) 886-6166",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Watertown — 50 miles north",
      website: "https://tools.usps.com/find-location.htm?location=1368555",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for Codington County and northern Brookings County residents. Passport photos available. Appointment recommended.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 230 miles to Minneapolis Passport Agency", fpc: "Most Brookings travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "SD-Specific Guidance", agency: "Generic — no SDSU, manufacturing, or eastern South Dakota expertise", fpc: "Full SDSU/corporate/Brookings County knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Underestimating First-Time Passport Timeline",
      description: "SDSU students and Brookings residents often plan international travel without realizing first-time passports require an in-person acceptance visit and take longer to process. We catch this early and expedite.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Brookings applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Brookings pharmacy and big-box store photos fail State Department standards. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Brookings County families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Rule",
      description: "Brookings travelers booking to Asia or Europe often do not know their passport must have 6 months remaining beyond the return date. We flag this immediately.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or dorm." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Brookings clients ship from home — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 230 miles to Minneapolis or wait at a post office." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Brookings?", a: "We offer Brookings-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit an office in Brookings?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Brookings post office or county clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Brookings address." },
    { q: "Where can I get a passport acceptance in Brookings?", a: "Brookings has passport acceptance at the Main Post Office (500 Main Ave) and the Brookings County Clerk of Courts (314 6th Ave). Nearby options include post offices in Flandreau, Madison, Sioux Falls, and Watertown. We maintain an updated list of all eastern South Dakota acceptance facilities." },
    { q: "How far is the nearest passport agency from Brookings?", a: "The Minneapolis Passport Agency (212 3rd Ave S, Minneapolis, MN) is approximately 230 miles northeast via I-29. It requires appointments for life-or-death emergencies only. For travel within 3–14 days, our registered courier service is the fastest legally available channel without the four-hour drive." },
    { q: "Can SDSU students get expedited passports?", a: "Yes. SDSU Jackrabbits studying abroad, attending international conferences, or participating in faculty-led programs abroad can use our expedited courier service. We understand university timelines and can process first-time and renewal passports in time for program start dates." },
    { q: "What documents do Brookings applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Brookings-specific checklist." },
    { q: "Can I get a passport photo in Brookings?", a: "Yes — the Brookings Main Post Office offers passport photos on-site. Additional photo locations include Lewis Drug, Walmart, and the SDSU campus post office. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "What airport should I use for international travel from Brookings?", a: "Sioux Falls Regional Airport (FSD) is 55 miles south with connections to Minneapolis–St. Paul (MSP), Chicago O'Hare (ORD), and Denver (DEN) — all major international gateways. Minneapolis–St. Paul International Airport is 230 miles northeast for direct international flights." },
    { q: "How do I check my Brookings passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Brookings to final return shipping typically matches your chosen speed tier." },
    { q: "Can you help 3M/Daktronics employees with corporate travel passports?", a: "Yes. We regularly assist Brookings manufacturing professionals with expedited passports for short-notice international business trips. We understand corporate travel timelines and can coordinate processing around your departure date." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Brookings Residents",
    intro: "Brookings' position as a university and manufacturing hub in eastern South Dakota creates unique passport timing challenges. Here's what Brookings travelers need to know.",
    cards: [
      {
        icon: "ri-graduation-cap-line",
        title: "SDSU Study Abroad & International Programs",
        subtitle: "South Dakota State University — 12,000+ students with growing global programs",
        description: "SDSU sends hundreds of students abroad each year through semester exchange, faculty-led summer programs, and spring break immersions. The acceptance-to-orientation pipeline is often just 6–10 weeks, requiring expedited passport processing for first-time applicants. Many SDSU students — especially first-generation college students — have never held a passport and need guidance through the DS-11 process.",
        tip: "SDSU study abroad deadlines are firm — there is no flexibility on program start dates. Apply for your passport as soon as you receive your acceptance letter, not when you book your flight.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "FSD — Sioux Falls Regional Airport",
        subtitle: "Joe Foss Field, 55 miles south of Brookings via I-29",
        description: "Sioux Falls Regional Airport provides daily connections to Minneapolis–St. Paul (MSP), Chicago O'Hare (ORD), and Denver (DEN) — all major international gateway airports. Brookings travelers typically fly FSD to MSP or ORD to connect to their international flights. The drive from Brookings to FSD takes about 50 minutes on I-29.",
        tip: "Factor in the 55-mile drive to FSD plus a domestic connection when calculating your passport timeline. A delayed passport means a missed connection and potentially a missed international flight.",
      },
      {
        icon: "ri-building-2-line",
        title: "Manufacturing & Corporate Travel",
        subtitle: "3M, Daktronics, Larson Manufacturing, Bel Brands USA",
        description: "Brookings hosts several major manufacturing employers with international operations. 3M's Brookings plant produces products for global markets. Daktronics — headquartered in Brookings — has installations and clients worldwide. Larson Manufacturing and Bel Brands (Babybel, Laughing Cow) maintain international supply chain connections. Short-notice business travel to Europe, Asia, and South America is common.",
        tip: "Manufacturing professionals should check passport validity the moment an international trip is discussed — not when flights are booked. Many Brookings business travelers discover expired passports with under 2 weeks to departure.",
      },
      {
        icon: "ri-road-map-line",
        title: "Eastern South Dakota Family & Heritage Travel",
        subtitle: "Strong agricultural roots and Scandinavian heritage connections",
        description: "Brookings County's agricultural heritage and significant Scandinavian-American population drives family travel to Norway, Sweden, Germany, and Denmark. Multi-generational family trips — grandparents, parents, children — often require multiple first-time passports simultaneously. The planning horizon is typically 3–6 months, which fits our standard expedited processing window.",
        tip: "Family groups should apply together rather than sequentially. A single missing passport in a family group means the entire trip is at risk. We can process multiple applications simultaneously.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Brookings & Cross-Border Canada Travel",
      description: "Eastern South Dakota's proximity to Manitoba and Ontario via I-29 creates regular cross-border travel. Canadian fishing trips, Winnipeg shopping excursions, and agricultural equipment expos require passport or passport card documentation. Many Brookings residents with expired passports discover this only when planning summer trips north.",
    },
  },
  destinations: {
    title: "Where Brookings Travelers Go — And Why Passports Get Urgent",
    intro: "Brookings County's unique mix of university, manufacturing, and agricultural travel creates diverse passport needs. Here are the most common international destinations and the urgency patterns we see.",
    stats: [
      { stat: "35%", label: "of Brookings expedited requests are SDSU study abroad or university-related" },
      { stat: "2–4 Weeks", label: "average lead time from trip booking to international departure for manufacturing professionals" },
      { stat: "Apr–Jun", label: "peak season when SDSU summer programs, family vacations, and agricultural trade shows overlap" },
      { stat: "230 Miles", label: "distance Brookings residents avoid by using our courier instead of driving to the Minneapolis agency" },
    ],
    destinations: [
      { name: "Norway & Sweden", context: "Strong Scandinavian heritage in Brookings County drives genealogical tourism and family visits", urgency: "Summer heritage trips booked 2–3 months in advance", icon: "ri-map-pin-2-line" },
      { name: "Germany", context: "3M and manufacturing supplier connections, SDSU engineering exchange programs, agricultural equipment trade fairs", urgency: "Corporate trips often 1–2 week notice for trade shows", icon: "ri-map-pin-2-line" },
      { name: "Spain", context: "Popular SDSU study abroad destination — semester programs in Barcelona, Madrid, and Seville", urgency: "Spring semester deadlines in November, summer deadlines in March", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "Daktronics Asia-Pacific installations, SDSU international student recruiting, manufacturing partnerships", urgency: "Business travel booked 2–3 weeks out with fixed meeting dates", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Fishing trips to Manitoba and Ontario, Winnipeg shopping, agricultural expos, cross-border family visits", urgency: "Summer trips planned 1–2 months out, passport card popular", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "Winter getaways from South Dakota cold, Cancun and Riviera Maya resorts, spring break travel", urgency: "Last-minute resort deals booked 3–4 weeks out during January–March", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other South Dakota Service Areas",
    crossLinksDesc: "We serve travelers across the Mount Rushmore State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Sioux Falls", route: "/sioux-falls" },
      { name: "Rapid City", route: "/rapid-city" },
      { name: "Aberdeen", route: "/aberdeen-sd" },
    ],
  },
  photoLocations: [
    { name: "Brookings Main Post Office", address: "500 Main Ave, Brookings, SD 57006", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Lewis Drug — Brookings", address: "619 6th St, Brookings, SD 57006", hours: "Mon–Fri 8 AM – 9 PM, Sat–Sun 9 AM – 6 PM" },
    { name: "Walmart Supercenter — Brookings", address: "2233 6th St, Brookings, SD 57006", hours: "Daily 7 AM – 11 PM", website: "https://www.walmart.com/" },
    { name: "SDSU Campus Post Office", address: "1420 Student Union Ln, Brookings, SD 57007", hours: "Mon–Fri 9 AM – 4 PM (academic year)" },
    { name: "Walgreens — Brookings", address: "910 22nd Ave S, Brookings, SD 57006", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/" },
    { name: "UPS Store — Brookings", address: "1736 6th St, Brookings, SD 57006", hours: "Mon–Fri 8 AM – 6 PM, Sat 9 AM – 2 PM", website: "https://www.theupsstore.com/" },
    { name: "Lewis Drug — Madison", address: "113 N Egan Ave, Madison, SD 57042", hours: "Mon–Fri 8 AM – 9 PM, Sat 9 AM – 6 PM" },
    { name: "FedEx Office — Sioux Falls", address: "3400 W 49th St, Sioux Falls, SD 57106", hours: "Mon–Fri 7:30 AM – 9 PM, Sat 9 AM – 6 PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    {
      name: "Brookings DPS Driver License Exam Station",
      address: "910 4th St, Brookings, SD 57006",
      hours: "Mon–Fri, 7:00 AM – 5:30 PM",
      note: "Driver licenses, REAL ID, written and road tests. Appointment recommended.",
      featured: true,
    },
    {
      name: "Sioux Falls DPS Driver License Exam Station",
      address: "3101 W Russell St, Sioux Falls, SD 57107",
      hours: "Mon–Fri, 7:00 AM – 5:30 PM",
      note: "Full-service DPS driver license office serving Minnehaha County. REAL ID available. Appointment strongly recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "FSD",
      name: "Sioux Falls Regional Airport (Joe Foss Field)",
      distance: "About 55 miles south of Brookings via I-29",
      address: "2801 N Jaycee Ln, Sioux Falls, SD 57104",
      note: "Primary airport for eastern South Dakota. Daily nonstop connections to MSP, ORD, and DEN — all major international gateways. About a 50-minute drive from Brookings.",
      flightUrl: "https://www.sfairport.com/",
      flightLabel: "FSD Airport Website",
      featured: true,
    },
    {
      code: "MSP",
      name: "Minneapolis–St. Paul International Airport",
      distance: "About 230 miles northeast of Brookings via I-29",
      address: "4300 Glumack Dr, St Paul, MN 55111",
      note: "Major international hub with nonstop service to Europe, Asia, and the Americas. Delta Air Lines hub. The nearest large international gateway to Brookings — about a 3.5-hour drive.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the South Dakota Department of Health Vital Records. Online, mail, or in-person options available.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through SD Department of Health Vital Records. Required for estate and legal matters.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Brookings County Register of Deeds. Certified copies available for name changes and legal purposes.",
      url: "https://www.brookingscountysd.gov/departments/register-of-deeds",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Brookings County Clerk of Courts. Required for name change passport corrections.",
      url: "https://www.brookingscountysd.gov/departments/clerk-of-courts",
    },
  ],
};